import worker from '../worker';

export default (data, force) => {
  return worker.start(data, force);
};
